import { groupBy } from 'lodash-es';
import { FC, useMemo } from 'react';
import { productStorages } from 'src/constants';
import { DeliveryItem } from 'src/schema/schema-packing-sheet';

import classes from './PackingSheetSummaryTable.module.scss';

interface PackingSheetSummaryTableProps {
  /** aggregateBagItems 결과(보관방법 순 정렬된 소분상품 합산 목록) */
  items: DeliveryItem[];
}

/**
 * 멤버별 소분상품 합산 목록. 보관방법(상온/냉장/냉동/기타)으로 구분하여 출력한다.
 */
const PackingSheetSummaryTable: FC<PackingSheetSummaryTableProps> = ({ items }) => {
  const storageGroups = useMemo(() => Object.entries(groupBy(items, (item) => item.storage ?? 'etc')), [items]);

  return (
    <div className={classes.summaryContainer}>
      {storageGroups.map(([storage, storageItems]) => {
        const half = Math.ceil(storageItems.length / 2);
        return (
          <div key={storage} className={`${classes.storageSection} ${classes[storage] ?? ''}`}>
            <div className={`${classes.storageTitle} ${classes[storage] ?? ''}`}>
              <div className={classes.titleCell}>
                <span className={classes.storageName}>
                  {productStorages[storage] ?? '기타'}{' '}
                  <span className={classes.storageCount}>{storageItems.length}종</span>
                </span>
                <span className={classes.quantityHeader}>수량</span>
              </div>
              <div className={classes.titleCell}>
                <span className={classes.storageName} />
                <span className={classes.quantityHeader}>수량</span>
              </div>
            </div>
            <div className={classes.gridContainer} style={{ gridTemplateRows: `repeat(${half}, auto)` }}>
              {storageItems.map((item, index) => (
                <div
                  key={`${item.label}-${item.productFeature}`}
                  className={[
                    classes.itemRow,
                    index >= half ? classes.secondColumn : '',
                    index === half - 1 || index === storageItems.length - 1 ? classes.columnEnd : '',
                  ].join(' ')}
                >
                  <div className={classes.itemLabel}>
                    <span className={classes.label}>{item.label}</span>
                    {item.productFeature && <span className={classes.productFeature}>{item.productFeature}</span>}
                  </div>
                  <div className={classes.itemQuantity}>{item.quantity}</div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PackingSheetSummaryTable;
